import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { map, skipWhile, switchMap, take } from 'rxjs/operators';

import { APP_STATES, initSelectors } from '@core/store';

import { isReadonly } from '../store/selectors/estate.selectors';

@Injectable({ providedIn: 'root' })
export class FarmerNatureReportingGuard {
  router = inject(Router);
  store = inject(Store);

  canActivate() {
    return this.store.select(initSelectors.getAppStatus).pipe(
      skipWhile((status) => status === APP_STATES.IDLE),
      take(1),
      switchMap(() => this.store.select(isReadonly)),
      map((readonly) => {
        if (readonly) {
          this.router.navigate(['/']);
        }
        return true;
      })
    );
  }
}
